import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import useGetHook from "../../customHooks/useGetHook";

const CreateStatusComponent = loadable(
  () => import("../../components/Status/CreateStatus")
);
const CreateStatus = () => {
  const { data: statusList, } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {},
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["status"],
    navigateURL: "/status-settings",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.STATUS}`;
    let formData = {
      ...values,
      next_status: values?.next_status?.map((item: any) => (item.id)) ?? []
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Status</span>
      </div>
      <CreateStatusComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        statusList={statusList}
      />
    </>
  );
};
export default CreateStatus;
